import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/ApiEndpoints";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// App_Setup - Get All (Read)
export const GetAll = createAsyncThunk(
  "customization/appsetup/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.HeatMap.heat_map_cab}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// App_Setup - Get (Read)
export const GetSingle = createAsyncThunk(
  "customization/appsetup/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Customization.App_Setup}/${id}`);
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// App_Setup - Create (Add)
export const Create = createAsyncThunk(
  "customization/appsetup/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Customization.App_Setup, data);
      return res; // The new App_Setup object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// App_Setup - Update
export const Update = createAsyncThunk(
  "customization/appsetup/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Customization.App_Setup}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// App_Setup - Delete
export const Delete = createAsyncThunk(
  "customization/appsetup/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Customization.App_Setup}/${id}`);
      return id; // Return the id of the deleted App_Setup
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// App_Setup - Status
export const Status = createAsyncThunk(
  "customization/appsetup/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Customization.App_Setup}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "heat_map_cab",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // const index = state.data.findIndex(
        //   (country) => country.id === action.payload?.data?.id
        // );
        // if (index !== -1) {
        //   state.data[index] = action.payload.data;
        // }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
